import type { ColorEnum } from '../enums/color.enum'

export class CssVariableUtils {
  static isCssVariable(value: string): boolean {
    return value.startsWith('--')
  }

  static getCssVariableValue(cssVariable: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(cssVariable)
  }

  static getHexColorFromColorName(colorName: ColorEnum): string {
    const cssVariable = `--color-${colorName}`
    return this.getCssVariableValue(cssVariable)
  }
}
